import { useContext, useEffect, useState } from 'react';
import { MessageSquare } from 'lucide-react';
import { AuthContext } from '../../../contexts/AuthContext';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { listenToProfileWall } from '../../../database/profileComments';
import ComposeBox from './ComposeBox';
import CommentItem from './CommentItem';

const ProfileWall = ({ ownerUserId }) => {
  const { currentUser, hasPermission } = useContext(AuthContext);
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(true);

  const canModerate = hasPermission('profileComments.moderate');
  const currentUid = currentUser?.uid || null;

  useEffect(() => {
    if (!ownerUserId) return undefined;
    setLoading(true);
    return listenToProfileWall(
      ownerUserId,
      (rows) => {
        setComments(rows);
        setLoading(false);
      },
      { canModerate, currentUid }
    );
  }, [ownerUserId, canModerate, currentUid]);

  return (
    <Card className="border-border/60 bg-background/40">
      <CardHeader>
        <div className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.3em] text-muted-foreground">
          <MessageSquare className="h-3 w-3" />
          Pin wall
        </div>
        <CardTitle className="font-display text-lg">
          {loading ? 'Comments' : `Comments · ${comments.length}`}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-5">
        <ComposeBox ownerUserId={ownerUserId} />
        {loading ? (
          <div className="h-20 animate-pulse rounded-md bg-muted/40" />
        ) : comments.length === 0 ? (
          <p className="text-sm text-muted-foreground">
            No comments yet. Be the first to leave one.
          </p>
        ) : (
          <ul className="-mt-2">
            {comments.map((c) => (
              <CommentItem key={c.id} comment={c} ownerUserId={ownerUserId} />
            ))}
          </ul>
        )}
      </CardContent>
    </Card>
  );
};

export default ProfileWall;
